import { FC, useMemo } from 'react';

import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useSMSSendersByMessageType } from '../../hooks/useSMSSendersByMessageType';
import { SMSSendersQueryContext, SMSSendersQueryContextState } from './SMSSendersQueryContext';

export const SMSSendersQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { liveTemplate } = useEditableFieldsContext();
  const messageTypeId = liveTemplate.messageType?.id;

  const queryOptions = useMemo(
    () => ({
      skip: !messageTypeId,
      variables: { id: messageTypeId },
    }),
    [messageTypeId],
  );

  const {
    errorMessage = '',
    hasError,
    isLoading,
    refetch,
    results,
  } = useSMSSendersByMessageType(queryOptions);

  const refetchSMSSenders = () => {
    refetch({ id: messageTypeId });
  };

  const context: SMSSendersQueryContextState = {
    errorMessage,
    hasError,
    isLoading,
    refetch: refetchSMSSenders,
    smsSenders: results,
  };

  return (
    <SMSSendersQueryContext.Provider value={context}>{children}</SMSSendersQueryContext.Provider>
  );
};
